import { Collapse } from 'antd';
import { items } from './handle/items.handle';

export default function ResponseCollapse(props) {
	return (
		<>
      <span>{props.userMessage}</span>
			<Collapse {...props} items={items(props?.devMessage)} />
		</>
	);
}
